var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{class:{'html_gary': _vm.html_gary},attrs:{"id":"app"}},[_c('Header'),_c('router-view',{staticClass:"tabs-fixed-top"}),_c('index_bottom')],1)}
var staticRenderFns = []

export { render, staticRenderFns }